import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import {
  KcDataService
} from '../../../kc-data.service'

import { TranslationService } from '@emilfreydigital/transifex-angular'
import { KcClientData, KcRegisterFinishViewData } from '../../../interfaces/kc-data.interface'

@Component({
  selector: 'customer-portal-revolution-register-finish',
  templateUrl: './revolution-register-finish.component.html'
})
export class RevolutionRegisterFinishComponent implements OnInit {
  constructor (
    private readonly kcDataService: KcDataService,
    private readonly transifexTranslationsService: TranslationService
  ) {}

  @ViewChild('registerFinishForm', { static: true })
  private readonly formRef: ElementRef

  public clientData: KcClientData
  public viewData: KcRegisterFinishViewData
  public submitting: boolean

  ngOnInit () {
    this.clientData = this.kcDataService.getClientData()
    this.viewData = this.kcDataService.getViewData() as KcRegisterFinishViewData
  }

  submit () {
    this.submitting = true

    // submit form
    const formElement = this.formRef.nativeElement as HTMLFormElement
    formElement.submit()
  }

  getTranslation (): string {
    return this.transifexTranslationsService.translate(
      'Welcome, {firstName}! You can now manage your vehicles online!',
      {
        _key: 'customerPortal.kc.register-finish.text',
        _tags: 'kc-forms, 3.1',
        firstName: this.viewData.firstName
      }
    )
  }
}
